import React from 'react';
import { createRoot } from 'react-dom/client';
import RecruiterToolsBelt from '../../src/recruiter_tools_belt/recruiter_tools_belt';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('recruiterToolsBelt');

  if (container) {
    const root = createRoot(container);
    root.render(
      <DevexHighOrderComponent>
        <RecruiterToolsBelt
          id={JSON.parse(container.dataset.id)}
          name={JSON.parse(container.dataset.name)}
          notes={JSON.parse(container.dataset.notes)}
          manageCuratedLists={JSON.parse(container.dataset.manageCuratedLists)}
          curatedCandidateLists={JSON.parse(container.dataset.curatedCandidateLists)}
        />
      </DevexHighOrderComponent>
    );
  }
});
